(function ($, Drupal, once) {
  Drupal.behaviors.pageModal = {
    attach(context) {
      once('pageModal', 'html', context).forEach((html) => {
        const navigation = html.querySelector('#navigation');

        // Open triggers: any data-modal that is not a close button
        const openTriggers = html.querySelectorAll('[data-modal]:not(.modal-close)');
        // Close triggers: modal-close links
        const closeTriggers = html.querySelectorAll('.modal-close[data-modal]');

        openTriggers.forEach((trigger) => {
          const selector = trigger.dataset.modal;
          const modal = html.querySelector(selector);
          const type = selector.replace('#', '').replace('-form', ''); // 'contact' or 'newsletter'
          const expandCls = `is-expanded-${type}`;

          trigger.addEventListener('click', (e) => {
            e.preventDefault();
            html.classList.add('prevent--overflow');
            navigation.classList.add(expandCls);
            ['contact', 'newsletter']
              .filter((t) => t !== type)
              .forEach((t) => navigation.classList.remove(`is-expanded-${t}`));
            // Set data attribute on modal for CSS if using data-variant
            trigger.dataset[`expanded${type.charAt(0).toUpperCase() + type.slice(1)}`] = 'true';
            modal.dataset[`expanded${type.charAt(0).toUpperCase() + type.slice(1)}`] = 'true';
          });
        });

        closeTriggers.forEach((trigger) => {
          const selector = trigger.dataset.modal;
          const modal = html.querySelector(selector);
          const type = selector.replace('#', '').replace('-form', '');
          const expandCls = `is-expanded-${type}`;

          trigger.addEventListener('click', (e) => {
            e.preventDefault();
            html.classList.remove('prevent--overflow');
            navigation.classList.remove(expandCls);
            // Reset data attribute on modal
            trigger.dataset[`expanded${type.charAt(0).toUpperCase() + type.slice(1)}`] = 'false';
            modal.dataset[`expanded${type.charAt(0).toUpperCase() + type.slice(1)}`] = 'false';
          });
        });
      });
    },
  };
}(jQuery, Drupal, once));
